import { render } from "./onboarding-phone-otp.vue?vue&type=template&id=7f25d92b"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__